import { Dispatch, SetStateAction, useState, VFC } from 'react'
import { SearchIconLarge } from 'src/assets/svgs'
import {
  _contributionsLabelBackground,
  _menuicon,
  _profilegreen,
  _searchbg,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

export const SearchFreeWord: VFC<{
  title: string
  selectedItems: string[]
  setSelectedItems: Dispatch<SetStateAction<string[]>>
}> = ({ title, selectedItems, setSelectedItems }) => {
  const [freeWord, setFreeWord] = useState<string>('')
  const onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13 && freeWord)
      if (!selectedItems.some((item) => item === freeWord))
        setSelectedItems([...selectedItems, freeWord])
  }
  const onClose = (item: string) => {
    setSelectedItems([
      ...selectedItems.filter((value: string) => value !== item),
    ])
  }
  return (
    <SearchFreeWordContent>
      <SearchFreeWordHeader>
        <SearchFreeWordTitle>
          <div>・</div>
          {title}
        </SearchFreeWordTitle>
      </SearchFreeWordHeader>
      <SearchFreeWordInputArea>
        <StyledSearchIcon />
        <SearchFreeWordInput
          placeholder="検索ワードを入力して、エンターキーをクリックしてください。"
          onKeyPress={(event) => onKeyPress(event)}
          onChange={({ target: { value } }) => setFreeWord(value)}
        />
      </SearchFreeWordInputArea>
      <SearchFreeWordItems>
        {selectedItems &&
          selectedItems.map((item, index) => {
            return (
              <SearchFreeWordItem key={`${index}`}>
                <SearchFreeWordItemContent>
                  <SearchFreeWordDiv>{item}</SearchFreeWordDiv>
                  <SearchFreeWordItemClearBtn onClick={() => onClose(item)}>
                    ×
                  </SearchFreeWordItemClearBtn>
                </SearchFreeWordItemContent>
              </SearchFreeWordItem>
            )
          })}
      </SearchFreeWordItems>
    </SearchFreeWordContent>
  )
}

const SearchFreeWordContent = styled.div`
  background: white;
  border-radius: 5px;
  margin: 10px 0px;
`
const SearchFreeWordHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16.5px;
  margin-left: 6px;
`

const SearchFreeWordTitle = styled.div`
  div {
    display: inline-block;
    margin-left: -12px;
    font-size: 32px;
    transform: translate(0px, 6px);
  }
`

const SearchFreeWordItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 0px 40px;
`

const SearchFreeWordItem = styled.div`
  display: flex;
  flex-direction: row;
`
const SearchFreeWordItemContent = styled.div`
  display: flex;
  flex-direction: row;
  margin: 4px 4px;
  padding: 4px 16px;
  background: ${_contributionsLabelBackground};
  border-radius: 14px;
  max-width: 100%;
`

const SearchFreeWordDiv = styled.div`
  display: inline-block;
  max-width: 100%;
  padding: 4px, 16px, 4px, 16px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${_profilegreen};
  font-weight: ${fontWeightBold};
`

const SearchFreeWordItemClearBtn = styled.div`
  display: inline-block;
  font-size: 14px;
  font-weight: ${fontWeightBold};
  color: ${_profilegreen};
  cursor: pointer;
  position: relative;
  top: 1px;
  padding-left: 14px;
`

const SearchFreeWordInputArea = styled.div`
  margin: 0px 40px;
  position: relative;
`
const StyledSearchIcon = styled(SearchIconLarge)`
  position: absolute;
  margin-left: 16px;
  margin-top: 16px;
  width: 19px;
  height: 19px;
`

const SearchFreeWordInput = styled.input`
  background-color: ${_searchbg};
  ::placeholder {
    color: ${_menuicon};
    font-size: 16px;
    font-weight: 400;
  }
  font-size: 16px;
  width: 572px;
  height: 51px;
  padding: 14px 14px 14px 46px;
  margin-bottom: 8px;
`
